






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataTableSetting, FieldEnum } from '@/components/shared';
import { customerService } from '@/services';
import { DataTableRequest, Customer } from '@/models';
import DataTable from '@/components/shared/table/DataTable.vue';

@Component({
  components: {
		DataTable,
  },
})
export default class SearchCustomerComponent extends Vue {
  @Prop() agencyId!: string;
	private searchText: string = '';
	private getItems: Function = new Function();
	private tableSetting: DataTableSetting = new DataTableSetting();
	private itemSelected?: Customer;
	private tableFields = [
    {
      'key': 'lastContractDate',
      'label': 'view.search_customer.contract_end_date',
      'type': FieldEnum.FIELD_DATE,
      'sortable': true,
      'thClass': 'text-center',
    },
    {
      'key': 'name',
      'label': 'view.search_customer.full_name',
      'type': FieldEnum.FIELD_TEXT,
      'sortable': true,
      'thClass': 'text-center',
    },
    {
      'key': 'furigana',
      'label': 'view.search_customer.furigana',
      'type': FieldEnum.FIELD_TEXT,
      'sortable': true,
      'thClass': 'text-center',
		},
	];

	private created() {
		// get all customer
		this.getItems = ((request: DataTableRequest) => {
			return customerService.getAllCusstomer(request, this.agencyId)
				.then((res) => {
					if (res.data.items && res.data.totalRows && this.tableSetting) {
						this.tableSetting.totalRows = res.data.totalRows;
						return res.data.items || [];
					}
				});
		});
		this.tableSetting = DataTableSetting.init(
      'name',
      'desc',
      this.tableFields,
      this.getItems,
      false,
      false,
		);
		// this.tableSetting.rowClickFunction = ((item: Customer) => this.loadDataSelected(item));
	}

  private itemsSelected(items: any) {
    if (items && items.length) {
      this.loadDataSelected(items[0])
    } else {
      this.loadDataSelected(new Customer)
    }
  }

	private search() {
		this.tableSetting.filter = this.searchText;
	}

	private loadDataSelected(item: Customer) {
		this.itemSelected = item;
	}
	private chooseCustomer() {
		this.$emit('chooseCustomer', this.itemSelected);
	}
}
